import { useState } from 'react';
import { FoldPanel, NamesInput, Specimens, Typography, type NamesProblem } from '@src/components';

const PROBLEM_COPY: Record<NamesProblem, string> = {
  invalid: 'A name must be 2–64 characters',
  duplicate: 'This name is already added',
  tooMany: 'You can add at most 8 participants here',
};

/** The names list used by the draw. Chips in, one control, no page CSS. */
export function NamesInputSection() {
  const [names, setNames] = useState(['Anna', 'Boris', 'Clara']);
  const [problem, setProblem] = useState<NamesProblem | null>(null);
  const [empty, setEmpty] = useState<string[]>([]);

  return (
    <FoldPanel
      id="names"
      title="Names input"
      hint="Comma, semicolon, newline or Enter commits a name. A pasted list becomes chips at once; Backspace on an empty line removes the last one. The screen owns the wording for a refused name."
      example={`<NamesInput
  names={names}
  onNamesChange={setNames}
  onProblem={setProblem}
  label="Participants"
  error={problem ? copy[problem] : undefined}
  hintEnd={<Typography as="span" role="meta/helper">{names.length}</Typography>}
/>`}
    >
      <Specimens
        label="With names"
        note="Max is 8 here so the limit is easy to hit. The chips are the Tag component."
      >
        <NamesInput
          names={names}
          onNamesChange={setNames}
          onProblem={setProblem}
          label="Participants"
          placeholder="Enter participant names…"
          hint="Separate names with commas or new lines."
          hintEnd={
            <Typography as="span" role="meta/helper" tabular>
              {names.length} / 8
            </Typography>
          }
          error={problem ? PROBLEM_COPY[problem] : undefined}
          removeLabel={(name) => `Remove ${name}`}
          maxNames={8}
          testId="kit-names"
        />
      </Specimens>

      <Specimens label="Empty" note="Three rows tall before anything is typed.">
        <NamesInput
          names={empty}
          onNamesChange={setEmpty}
          label="Participants"
          placeholder="Enter participant names…"
          rows={3}
          testId="kit-names-empty"
        />
      </Specimens>

      <Specimens label="Disabled" note="Chips keep their shape; nothing can be removed.">
        <NamesInput
          names={['Anna', 'Boris']}
          onNamesChange={() => {}}
          label="Participants"
          disabled
          rows={2}
          testId="kit-names-disabled"
        />
      </Specimens>
    </FoldPanel>
  );
}
